import React from "react";

/**
 * Minimal modal shell — 40% black backdrop, click-outside to close, and
 * stops event bubbling on the inner card. Shared by every PM modal.
 */
export default function ModalShell({ onClose, children, testid, size = "lg" }) {
  const widthClass = size === "xl" ? "max-w-4xl" : size === "md" ? "max-w-md" : "max-w-lg";
  return (
    <div
      className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4"
      onClick={onClose}
      data-testid={testid}
    >
      <div
        className={`bg-white w-full ${widthClass} rounded-lg shadow-xl overflow-hidden max-h-[92vh] flex flex-col`}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
}
